// Import the creation function for all of the different types
// of instance-able stores so they can be mapped to a type string.
import { getAssignmentsStoreFor } from 'Stores/AssignmentsStore'
import { getAttachmentsStoreFor } from 'Stores/AttachmentsStore'
import { getBidsStoreFor } from 'Stores/BidsStore'
import { getEventsStoreFor } from 'Stores/EventsStore'
import { getJobsStoreFor } from 'Stores/JobsStore'
import { getPaymentMethodsStoreFor } from 'Stores/PaymentMethodsStore'
import { getUsersStoreFor } from 'Stores/UsersStore'
import { getBusinessesStoreFor } from 'Stores/BusinessesStore'
import { getVirtualBankLineItemsStoreFor } from 'Stores/VirtualBankLineItemsStore'
import { getVirtualBankAccountsStoreFor } from 'Stores/VirtualBankAccountsStore'

export default function (type) {
  return {
    'Assignments': getAssignmentsStoreFor,
    'Attachments': getAttachmentsStoreFor,
    'Businesses': getBusinessesStoreFor,
    'Bids': getBidsStoreFor,
    'Events': getEventsStoreFor,
    'Jobs': getJobsStoreFor,
    'PaymentMethods': getPaymentMethodsStoreFor,
    'Users': getUsersStoreFor,
    'AgencyUsers': getUsersStoreFor,
    'BusinessUsers': getUsersStoreFor,
    'VirtualBankAccounts': getVirtualBankAccountsStoreFor,
    'VirtualBankLineItems': getVirtualBankLineItemsStoreFor,
  }[type]
}
